import Dealer from "models/dealerPurchase/dealer";
import axiosRequestUtility from "../utilities/AxiosRequestUtility";
import DealerSalesman from "models/dealerPurchase/dealerSalesman";
import publicAxiosRequestUtility from "utilities/PublicAxiosRequestUtility";
import EquipmentProduct from "models/dealerPurchase/equipmentProduct";
import DownloadDocumentResponse from "models/downloadDocumentResponse/DownloadDocumentResponse";
import globalUtility from "utilities/GlobalUtility";

class DealerService {
  public GetDealersPublic(): Promise<Dealer[]> {
    return publicAxiosRequestUtility.Request({
      method: 'GET',
      url: `GetDealersPublic`,
    })
      .then(response => {
        return response.data as Dealer[]
      })
      .catch(error => {
        console.log(error);
        alert('Error loading dealers. Please try again.')
        return [];
      })
  }

  public GetDealers(): Promise<Dealer[]> {
    return axiosRequestUtility.Request({
      method: 'GET',
      url: `GetDealers`,
    })
      .then(response => {
        return response.data as Dealer[]
      })
      .catch(error => {
        console.log(error);
        alert('Error loading dealers. Please try again.')
        return [];
      })
  }

  public GetDealerWhiteLabelInfo(sqId: string): Promise<Dealer> {
    return publicAxiosRequestUtility.Request({
      method: 'GET',
      url: `GetDealerWhiteLabelInfo`,
      params: {
        sqId: sqId
      }
    })
      .then(response => {
        return response.data as Dealer;
      })
      .catch(error => {
        console.log(error);
        alert('Error retrieving partner financing information. Please try again.');
        return {} as Dealer;
      })
  }

  public DownloadWhiteLabelLogo(fileLocation: string): Promise<DownloadDocumentResponse> {
    return publicAxiosRequestUtility.Request({
      method: 'POST',
      responseType: 'arraybuffer',
      url: `DownloadWhiteLabelLogo`,
      params:
      {
        'fileLocation': fileLocation
      }
    })
      .then(response => {
        return globalUtility.CreateFileDownloadResponse(response);
      })
      .catch(error => {
        alert('Error downloading partner financing logo. Please try again.')
        return {} as DownloadDocumentResponse;
      })
  }

  public GetSalesmanInformation(salesmanId: number): Promise<DealerSalesman> {
    return axiosRequestUtility.Request({
      method: 'GET',
      url: `GetSalesmanInformation`,
      params: {
        id: salesmanId
      }
    })
      .then(response => {
        return response.data as DealerSalesman
      })
      .catch(error => {
        console.log(error);
        alert('Error loading salesman information. Please try again.')
        return {} as DealerSalesman;
      })
  }

  public GetDealerEquipmentProductsPublic(dealerId: number): Promise<EquipmentProduct[]> {
    return publicAxiosRequestUtility.Request({
      method: 'GET',
      url: 'GetDealerEquipmentProductsPublic',
      params: {
        'dealerId': dealerId
      }
    })
      .then(response => {
        return response.data as EquipmentProduct[];
      })
      .catch(error => {
        console.log(error);
        alert('Error retrieving equipment products. Please try again.')
        return [];
      })
  }

  public GetDealerEquipmentProducts(dealerId: number): Promise<EquipmentProduct[]> {
    return axiosRequestUtility.Request({
      method: 'GET',
      url: 'GetDealerEquipmentProducts',
      params: {
        'dealerId': dealerId
      }
    })
      .then(response => {
        return response.data as EquipmentProduct[];
      })
      .catch(error => {
        console.log(error);
        alert('Error retrieving equipment products. Please try again.')
        return [];
      })
  }
}

const dealerService = new DealerService();
export default dealerService;